import { createApp } from 'vue'
import App from './App.vue'
// 导入路由实例
import router from './router'
// 导入Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 导入Element Plus图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 创建应用实例
const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// 使用路由 - 这一步非常重要，否则router-view无法识别
app.use(router)
// 使用Element Plus
app.use(ElementPlus)

// 挂载应用
app.mount('#app')
